import { useEffect, useState } from "react";
import "../styles/BottomNavBar.scss";
import navigate from "../utilities/navigation";
import { useSelector } from "react-redux";
import actions from "../actions/actions";
import { useLogoutIfAccessDisabled } from "../utilities/hooks";
import { UserRole, Path } from "../utilities/constants";

const BottomNavBar = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const location = window.location;
  let loginUser = useSelector((store) => store.user);

  // Forcefully log out user if access is disabled
  useLogoutIfAccessDisabled(loginUser);

  // Menu logic: userType 1,2,3 with read_only: only Dashboard; userType 1,2,3 without read_only: Dashboard, Groups, Messages; others: all
  const isMemberOrStaff = [1, 2, 3].includes(loginUser?.userType);

  // Redirect to dashboard if user manually enters another URL
  useEffect(() => {
    if (
      isMemberOrStaff &&
      loginUser?.read_only &&
      location.pathname !== Path.Dashboard
    ) {
      navigate(Path.Dashboard);
      return;
    }
    // Restrict Members from accessing Groups page via URL
    if (
      loginUser?.userType === UserRole.Member &&
      location.pathname === Path.Groups &&
      location.pathname === Path.People
    ) {
      actions.user.logout();
      return;
    }
    // Restrict non-Admins from accessing protected pages via URL
    const protectedAdminPages = [
      // Path.People,
      Path.ReportCommunication,
      Path.ReportRecent,
      Path.ReportInvalidContacts,
      Path.ReportOptOut,
    ];
    if (
      loginUser?.userType !== UserRole.Admin &&
      protectedAdminPages.includes(location.pathname)
    ) {
      actions.user.logout();
    }
  }, [
    isMemberOrStaff,
    loginUser?.read_only,
    loginUser?.userType,
    location.pathname,
  ]);

  // Restrict Members from accessing Groups page via URL
  useEffect(() => {
    if (
      loginUser?.userType === UserRole.Member &&
      location.pathname === "/groups"
    ) {
      navigate("/"); //Change to dashboard or another appropriate page
    }
  }, [loginUser?.userType, location.pathname]);

  useEffect(() => {
    if (location.pathname === "/") {
      setActiveTab("dashboard");
    } else if (location.pathname === "/messages") {
      setActiveTab("messages");
    } else if (
      location.pathname === "/people" ||
      location.pathname.startsWith("/people-dashboard/")
    ) {
      setActiveTab("people");
    } else {
      setActiveTab("groups");
    }
  }, [location.pathname]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "dashboard") {
      navigate("/");
    }
    if (tab === "messages") {
      navigate("/messages");
    }
    if (tab === "people") {
      navigate("/people");
    }
    if (tab === "groups") {
      navigate("/groups");
    }
  };

  return (
    <div className="bottom-nav-bar">
      {loginUser?.userType && (
        <>
          {/* Always show Dashboard */}
          <div
            className={`nav-item ${activeTab === "dashboard" ? "active" : ""}`}
            onClick={() => handleTabChange("dashboard")}
          >
            <i className="fa fa-home"></i>
            <span>My Dashboard</span>
          </div>
          {/* userType 1,2,3 with read_only: only Dashboard */}
          {/* userType 1,2,3 without read_only: Dashboard, Groups, Messages */}
          {/* others: all */}
          {isMemberOrStaff && loginUser?.read_only ? null : (
            <>
              {/* userType 1,2,3 without read_only: show Messages, Groups; others: show all */}
              <div
                className={`nav-item ${
                  activeTab === "messages" ? "active" : ""
                }`}
                onClick={() => handleTabChange("messages")}
              >
                <i className="fa fa-paper-plane"></i>
                <span>Messages</span>
              </div>
              {/* Hide people for Members */}
              {loginUser?.userType !== UserRole.Member && (
                <div
                  className={`nav-item ${
                    activeTab === "people" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("people")}
                >
                  <i className="fa fa-user"></i>
                  <span>People</span>
                </div>
              )}
              {/* Hide groups for Members */}
              {loginUser?.userType !== UserRole.Member && (
                <div
                  className={`nav-item ${
                    activeTab === "groups" ? "active" : ""
                  }`}
                  onClick={() => handleTabChange("groups")}
                >
                  <i className="fa fa-users"></i>
                  <span>Groups</span>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default BottomNavBar;
